import { FACE_DETECTION_CONFIG } from '../config/config';
import logger from './logger';

/**
 * Service de détection de visage via le backend GCP
 * Vérifie qu'une image contient bien un visage avant de la valider
 */

/**
 * Détecte la présence d'un visage dans une image base64
 * @param {string} imageBase64 - Image en base64 (avec ou sans préfixe data:image/...)
 * @returns {Promise<{has_face: boolean, message: string|null}>}
 */
export const detectFace = async (imageBase64) => {
  try {
    if (!imageBase64) {
      throw new Error('Image requise');
    }

    if (!FACE_DETECTION_CONFIG.BASE_URL) {
      logger.warn('⚠️ REACT_APP_FACE_DETECTION_URL non configurée, validation ignorée');
      return { has_face: true, message: null };
    }

    logger.log('🔍 Vérification de la présence d\'un visage...');

    const response = await fetch(
      `${FACE_DETECTION_CONFIG.BASE_URL}${FACE_DETECTION_CONFIG.ENDPOINT}`,
      {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          image_base64: imageBase64,
        }),
      }
    );

    if (!response.ok) {
      const errorData = await response.json().catch(() => ({}));
      throw new Error(errorData.detail || `Erreur HTTP: ${response.status}`);
    }

    const data = await response.json();
    logger.log(data.has_face ? '✅ Visage détecté' : '❌ Aucun visage détecté');

    return {
      has_face: data.has_face,
      message: data.message || null,
    };
  } catch (error) {
    logger.error('❌ Erreur lors de la détection de visage:', error);
    throw error;
  }
};
